import React, { useState } from "react";
import {
  MDBFile,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCheckbox,
  MDBValidation,
  MDBTextArea,
  MDBBtn,
  MDBInput,
} from "mdb-react-ui-kit";

import { useSelector } from "react-redux";
import axios from "axios";
import validateTemplateBase64Data from "../../utilities/validateTemplateBase64Data";
import { toast } from "react-toastify";
import fingerPrintServices from "../../utilities/demo";
import Loader from "../Loader";
import convertToUnderscoreFormat from "../../utilities/convertToUnderscoreFormat";
import ScannerLoader from "../ScannerLoader";
import API_BASE_URL from "../../utilities/apiConfig";
import axiosInstance from "../../utilities/apiConfig";
const DeleteAdvocateDetails = () => {
  const [barId, setBarid] = useState("");
  const [loading, setLoading] = useState(false);
  const [fingerprintverified, setfingerprintVerified] = useState("");
  const [userFingerprint, setUserFingerprint] = useState("");
  const [secugenLic, setSecugenLic] = useState("");
  const [quality, setQuality] = useState(100);
  const token = useSelector((state) => state.auth.token);

  const [isFingerPrintScannerinProgress, setIsFingerPrintScannerinProgress] =
    useState(false);

  const userDeatils = useSelector((state) => state.auth?.userData?.authUser);

  const { userId, fingerprintData } = userDeatils;

  const fingerPrintService = fingerPrintServices();

  const successFunc2 = (result) => {
    setIsFingerPrintScannerinProgress(false);
    if (
      result.ErrorCode === 0 &&
      result != null &&
      result.BMPBase64.length > 0
    ) {
      console.log("Finger Print Data", result.TemplateBase64);
      setUserFingerprint(result.TemplateBase64);
      console.log("Finger Print Image", result.BMPBase64);

      handleVerifyFingerPrint(result.TemplateBase64, fingerprintData);
    } else {
      if (result.ErrorCode === 3) {
        toast.error("Please check your fingerprint device");
      } else if (result.ErrorCode === 54) {
        toast.error("Timeout, scan your finger again");
      } else {
        toast.error("Please scan your finger again");
      }
    }
  };

  // Error callback function
  const errorFunc = (status) => {
    setIsFingerPrintScannerinProgress(false);
    toast.error("Please Check Secugen fingerprit service is working properly");
    // toast.error(`Check if SGIBIOSRV is running; status = ${status}:`);
  };

  const callSGIFPGetData = () => {
    setIsFingerPrintScannerinProgress(true);
    const uri = "https://localhost:8000/SGIFPCapture";
    const params = new URLSearchParams({
      Timeout: 10000,
      Quality: 50,
      licstr: secugenLic,
      templateFormat: "ISO",
    });

    axios
      .post(uri, params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        successFunc2(response.data);
      })
      .catch((error) => {
        errorFunc(error);
      });
  };

  const handleVerifyFingerPrint = async (userFingerprint, fingerprintData) => {
    try {
      setLoading(true);
      const condition1 = validateTemplateBase64Data(fingerprintData);
      const condition2 = validateTemplateBase64Data(userFingerprint);
      console.log(condition1);
      if (condition1 && condition2) {
        const response = await fingerPrintService.matchFingerPrint(
          fingerprintData,
          userFingerprint,
          fingerPrintService.succMatch,
          fingerPrintService.failureFunc
        );
        console.log("Response of Matching:", response);
        if (response.matched) {
          deleteRecordsUsingReferenceBarId();
        } else {
          toast.error("FingerPrint Not Matched");
        }
      } else {
        toast.error("Please scan your fingerprint again");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error : Finger Data Not Verified");
      // Handle the error here
    } finally {
      setLoading(false);
    }
  };

  const deleteRecordsUsingReferenceBarId = async (referenceBarId) => {
    if (referenceBarId !== null) {
      const formatted_bar_id = convertToUnderscoreFormat(barId);
      try {
        setLoading(true);
        const response = await axiosInstance.delete(
          `/Verification/delete_records_using_advocate_bar_id_and_user_id/${formatted_bar_id}/${userId}`,
          {
            headers: {
              "Content-Type": "application/problem+json; charset=utf-8",
              Authorization: `Bearer ${token}`, // Include the token in the request header
            },
          }
        );
        console.log("API Response:", response.data);
        if (response.data.statusCode === 200) {
          toast.success(response.data.status);
        } else {
          toast.error(response.data.status);
        }
      } catch (error) {
        console.error("Error deleting records:", error);
        toast.error("An Unexpected Error Occured Please Try again");
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Please Enter bar id");
    }
  };

  return (
    <>
      {loading && <Loader />}
      {isFingerPrintScannerinProgress && <ScannerLoader />}
      <div className="row justify-content-center mb-4  mt-5">
        <div className="col-xxl-8">
          <div className="row text-center">
            <h2>Delete Incorrect Entry</h2>
          </div>
        </div>
      </div>
      <div className="mt-5">
        <div className="row mb-5 justify-content-center my-5 pb-5">
          <div
            feedback="Please Enter Bar Id."
            invalid
            className="col-md-3 mb-1 d-flex justify-content-end"
          >
            <MDBInput
              required
              value={barId}
              onChange={(e) => setBarid(e.target.value)}
              label="Enter Bar Id"
              type="text"
              name="barId"
              className="m-0"
              id="barId"
            />
          </div>
          <div className="col-md-2 mb-1 ">
            <MDBBtn
              color="danger"
              onClick={() => {
                callSGIFPGetData();
              }}
            >
              Delete
            </MDBBtn>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteAdvocateDetails;
